import { AuthHeaderWrapper, AuthHeaderTitle, AuthHeaderSubtitle } from './styled';

export interface AuthHeaderProps {
  title: string;
  subtitle?: string;
}

/**
 * Header component for authentication forms displaying title and optional subtitle.
 *
 * @component
 * @example
 * ```tsx
 * <AuthHeader
 *   title="Welcome Back"
 *   subtitle="Sign in to continue"
 * />
 * ```
 *
 * @param {string} title - Main heading text
 * @param {string} [subtitle] - Optional subheading text
 */
export function AuthHeader({ title, subtitle }: AuthHeaderProps) {
  return (
    <AuthHeaderWrapper>
      <AuthHeaderTitle>{title}</AuthHeaderTitle>
      {subtitle && <AuthHeaderSubtitle>{subtitle}</AuthHeaderSubtitle>}
    </AuthHeaderWrapper>
  );
}
